import React from 'react';
import * as Icons from 'lucide-react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { documentTypes } from '../../data/content';
import { getServiceDetailPath } from '../../data/serviceProducts';

export default function DocumentsSection({ showAll = false }) {
  const { t } = useLanguage();
  const items = showAll ? documentTypes : documentTypes.slice(0, 8);

  return (
    <section className="section" style={{ background: 'var(--gray-50)' }}>
      <div className="container">
        <div className="section-header">
          <h2>{t.documents.title}</h2>
          <p>{t.documents.subtitle}</p>
        </div>
        <div className="grid-4">
          {items.map((doc) => {
            const Icon = Icons[doc.icon];
            const detailPath = getServiceDetailPath(doc.id);

            return (
              <div key={doc.id} className="card doc-card">
                <div className="icon-box">
                  <Icon size={22} />
                </div>
                <h3>
                  <Link to={detailPath}>{t.documents[doc.id]}</Link>
                </h3>
                <p className="doc-price">
                  {t.documents.from} <strong>{doc.price}</strong> {t.documents.perPage}
                </p>
                <div className="doc-card-actions">
                  <Link to={detailPath} className="btn btn-teal">
                    {t.serviceCatalog.learnMore}
                    <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
